export const borders = {}